export type TReportingPeriodTypeId = number;

export interface ReportingPeriodType {
  id: TReportingPeriodTypeId;
  type?: string;
  name?: string;
}
